import {
  SET_ALREADY_SET_DEGREE_LIST,
  SET_CORP_LIST,
  SET_DEGREE_STREAM_MAP,
  SET_ROLES_LIST,
  SET_RULE_DETAILS,
  SET_RULE_ENGINE,
  SET_RULE_LIST,
  SET_RULE_LIST_WAY,
  SET_RULES_DEGREES_METRICS,
} from 'modules/RuleEngine/action'
import {
  SET_IS_RULES_EDITED,
  SET_RULES_STATIC_DETAILS,
  SET_SELECTED_DEGREE_DEPARTMENT,
} from './action'

const initialState = {
  rolesList: [],
  ruleEngine: {},
  corpList: [],
  ruleSet: [],
  ruleDetailsById: {},
  alreadySetDegreeList: [],
  rulesDegreesMetrics: [],
  selectedDegreesAndDepartList: {
    check: false,
    list: [],
  },
  ruleDegreeStreamMap: [],
  ruleWay: false,
  rulesStaticDetails: {},
  isRuleEdited: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLES_LIST:
      return {
        ...state,
        rolesList: action.data,
      }
    case SET_RULE_ENGINE:
      return {
        ...state,
        ruleEngine: action.data,
      }
    case SET_CORP_LIST:
      return {
        ...state,
        corpList: action.data,
      }
    case SET_RULE_LIST:
      return {
        ...state,
        ruleSet: action.data,
      }
    case 'DELETE_RULE_SUCCESS':
      return {
        ...state,
        ruleSet: state.ruleSet.filter(rule => rule.id !== action.ruleId),
      }
    case SET_RULE_DETAILS:
      return {
        ...state,
        ruleDetailsById: action.data,
      }
    case SET_ALREADY_SET_DEGREE_LIST:
      return {
        ...state,
        alreadySetDegreeList: action.data,
      }
    case SET_DEGREE_STREAM_MAP:
      return {
        ...state,
        ruleDegreeStreamMap: action.data,
      }
    case SET_RULE_LIST_WAY:
      return {
        ...state,
        ruleWay: action.data,
      }
    case SET_RULES_DEGREES_METRICS:
      return {
        ...state,
        rulesDegreesMetrics: action.data,
      }

    case SET_SELECTED_DEGREE_DEPARTMENT:
      return {
        ...state,
        selectedDegreesAndDepartList: {
          check: action.data?.check,
          list: action?.data?.list,
        },
      }
    case SET_RULES_STATIC_DETAILS:
      return {
        ...state,
        rulesStaticDetails: action.data,
      }
    case SET_IS_RULES_EDITED:
      return {
        ...state,
        isRuleEdited: action.data,
      }
    default:
      return state
  }
}
